<template>
  <v-dialog :model-value="isShow" persistent max-width="500" min-width="500">
    <v-card class="pt-7 text-center border-radius-8">
      <v-card-title class="pa-0 justify-center font-weight-bold font-color-5">{{
        $t("dialogs.unexpectedError.title")
      }}</v-card-title>
      <v-card-text class="pa-0 mt-5 font-size-16 text-gray-40">{{
        $t("dialogs.unexpectedError.description")
      }}</v-card-text>
      <v-card-actions class="pa-0">
        <div class="mx-auto my-7">
          <v-btn variant="flat" color="primary" class="btn-common" @click="isShow = false">{{
            $t("buttons.close")
          }}</v-btn>
        </div>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script lang="ts">
import { defineComponent } from "vue";

export default defineComponent({
  computed: {
    isShow: {
      get() {
        return this.$store.state.dialogs.unexpectedError;
      },
      set(value: boolean) {
        this.$store.commit("showDialog", { name: "unexpectedError", value });
      },
    },
  },
});
</script>
